import { Service } from "./service"

export const TaxService = Service


// WEBPACK FOOTER //
// ./src/state/tax/service/index.ts